import joi from 'joi';

import {
  type GraphOverlayRequest,
  graphOverlayRequestSchema,
} from '../graphOverlay';
import { graphSettingsSchema } from '../graphSettings';
import type { PathLookupGraphSettings } from '../graphSettings/PathLookupGraphPreset';
import type { TopologyGraphSettings } from '../graphSettings/TopologyGraphPreset';
import {
  type GraphView,
  type GraphViewBase,
  type GraphViewPreviewable,
  type WithPreview,
  graphViewBaseSchema,
} from '../graphView';

export type GraphViewRequestBodyBase = GraphViewBase & {
  overlay?: GraphOverlayRequest;
  settings: TopologyGraphSettings | PathLookupGraphSettings;
};

export type GraphViewRequestBody = GraphViewRequestBodyBase & WithPreview;

export type GraphViewResponseBodyBase = GraphView;

export type GraphViewResponseBody = GraphViewPreviewable;

export const graphViewRequestBodyBaseSchema = graphViewBaseSchema.keys({
  overlay: graphOverlayRequestSchema,
  settings: graphSettingsSchema.required(),
});

export const graphViewRequestBodySchema = graphViewRequestBodyBaseSchema.keys({
  preview: joi.string().base64().required(), // image in base64
});
